import React, { useEffect } from "react";
import { Outlet, useNavigate } from "react-router-dom";
import { Sidebar } from "./Sidebar";
import { Toaster } from "../ui/sonner";
import { useApp } from "../../context/AppContext";
import { Eye, X } from "lucide-react";

const getRoleLabel = (role) => {
    const roles = {
        admin: "Administrateur",
        agent: "Agent IT",
        coordinator: "Coordinateur",
        approver: "Approbateur",
        user: "Utilisateur",
    };
    return roles[role] || role;
};

export function Layout() {
    const { impersonating, currentUser, realUser, stopImpersonation } = useApp();
    const navigate = useNavigate();

    const handleStopImpersonation = () => {
        stopImpersonation();
        navigate("/");
    };

    // Ctrl+K → /search
    useEffect(() => {
        const handler = (e) => {
            if ((e.ctrlKey || e.metaKey) && e.key === "k") {
                e.preventDefault();
                navigate("/search");
            }
        };
        window.addEventListener("keydown", handler);
        return () => window.removeEventListener("keydown", handler);
    }, [navigate]);

    return (
        <div className="app-layout">
            <Sidebar />
            <main className="main-content">
                {impersonating && (
                    <div
                        className="sticky top-0 z-[9999] bg-amber-500 text-white px-6 py-2.5 flex items-center justify-between print:hidden shadow-md"
                        data-testid="impersonation-topbar"
                    >
                        <div className="flex items-center gap-2.5 text-sm font-medium">
                            <Eye className="w-4 h-4 flex-shrink-0" />
                            <span>
                                Mode observation — Vous voyez l'interface de{" "}
                                <strong>{currentUser?.first_name} {currentUser?.last_name}</strong>
                                {" "}
                                <span className="inline-flex items-center px-1.5 py-0.5 rounded text-[10px] font-semibold bg-white/20 ml-1">
                                    {getRoleLabel(currentUser?.role)}
                                </span>
                            </span>
                        </div>
                        <button
                            onClick={handleStopImpersonation}
                            className="flex items-center gap-1.5 px-3 py-1.5 text-xs font-semibold bg-white text-amber-700 hover:bg-amber-50 rounded-md transition-colors"
                            data-testid="stop-impersonation-topbar-btn"
                        >
                            <X className="w-3.5 h-3.5" />
                            Quitter l'observation
                        </button>
                    </div>
                )}
                <Outlet />
            </main>
            <Toaster position="bottom-right" />
        </div>
    );
}
